import { render, staticRenderFns } from "./CobranzaPolizasActivas.vue?vue&type=template&id=305572a6"
import script from "./CobranzaPolizasActivas.vue?vue&type=script&lang=js"
export * from "./CobranzaPolizasActivas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports